import React from 'react'
import { InputAdornment, Slider, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { SliderThumb } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import { useEffect, useRef } from 'react';
import { FlashAutoRounded } from '@mui/icons-material';
import DisplayTypeCompanentFOne from './DisplayTypeCompanentFOne';

const AirbnbSlider = styled(Slider)(({ theme }) => ({
  color: '#ff6614',
  height: 3,
  padding: '13px 0',
  '& .MuiSlider-thumb': {
    height: 27,
    width: 27,
    backgroundColor: '#fff',
    border: '1px solid currentColor',
    '&:hover': {
      boxShadow: '0 0 0 8px rgba(58, 133, 137, 0.16)',
    },
    '& .airbnb-bar': {
      height: 9,
      width: 1,
      backgroundColor: 'currentColor',
      marginLeft: 1,
      marginRight: 1,
    },
  },
  '& .MuiSlider-track': {
    height: 3,
  },
  '& .MuiSlider-rail': {
    color: theme.palette.mode === 'dark' ? '#bfbfbf' : '#d8d8d8',
    opacity: theme.palette.mode === 'dark' ? undefined : 1,
    height: 3,
  },
}));

function AirbnbThumbComponent(props) {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      <span className="airbnb-bar" />
      <span className="airbnb-bar" />
      <span className="airbnb-bar" />
    </SliderThumb>
  );
}

AirbnbThumbComponent.propTypes = {
  children: PropTypes.node,
};

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}


function DisplayTypeCompanentA(props) {
  const [getchecked, setGetChecked] = React.useState(false);
  const [checked, setChecked] = React.useState(props.checked);
  const [valuemin, setValueMin] = React.useState(Number(props.propertyValue[0]));
  const [valuemax, setValueMax] = React.useState(Number(props.propertyValue[1]));



  const prevChecked = usePrevious(checked);
  const prevGetChecked = usePrevious(getchecked);

  // if (!props.propertyValue[0]) { setValueMin(1); }
  // if (!props.propertyValue[1]) { setValueMax(420); }

  const handleChange = (event, newValue) => {
    setValueMin(newValue[0]);
    setValueMax(newValue[1]);
    setGetChecked(false);
  };

  const showMouseUp = () => {
    checked[props.code] = [String(valuemin), String(valuemax)];
    setChecked(checked);
    props.setCheckenFiltr(checked);
    setGetChecked(true);
  };


  useEffect(() => {

    if (getchecked == true) {

      console.log("старое useEffect", prevChecked);
      console.log("новое useEffect", checked);
      console.log("запуск", getchecked, [valuemin, valuemax]);
      props.submitForm();

    }
  }, [getchecked, [valuemin, valuemax]])



  const handleChangestart = (event) => {
    if (event.target.value >= valuemin)
      setValueMin(event.target.value);
  };
  const handleChangeend = (event) => {
    if (event.target.value <= valuemax)
      setValueMax(event.target.value);
  };

  return (
    <>
      <Typography sx={{ mt: 1, mb: 1, fontWeight: 600 }} variant="h6" component="div">
        {props.name}
      </Typography>

      <Box sx={{ width: '100%' }}>
        <Stack
          direction="row"
          divider={<Divider orientation="horizontal" flexItem />}
          spacing={2}
        >
          <TextField
            min={props.propertyValue[0]}
            label="от"
            onChange={handleChangestart}
            value={valuemin}
            type="number"
            id="outlined-start-adornment"
            sx={{ m: 0, width: '15ch', backgroundColor: "#ffffff" }}
            InputProps={{
              startAdornment: <InputAdornment position="start"></InputAdornment>,
            }}
          />
          <TextField
            type="number"
            max={props.propertyValue[1]}
            value={valuemax}
            onChange={handleChangeend}
            label="до"
            id="outlined-start-adornment"
            sx={{ m: 1, width: '15ch', backgroundColor: "#ffffff" }}
            InputProps={{
              startAdornment: <InputAdornment position="start"></InputAdornment>,
            }}
          />
        </Stack >
      </Box>

      <Box sx={{ width: '100%' }} >
        <AirbnbSlider sx={{ mt: 2 }}
          valueLabelDisplay="auto"
          components={{ Thumb: AirbnbThumbComponent }}
          onChange={handleChange}
          value={[valuemin, valuemax]}
          min={Number(props.propertyValue[0])}
          max={Number(props.propertyValue[1])}
          onMouseUp={showMouseUp}
        />
      </Box>
      {props.code == "width" &&

        <>
          <DisplayTypeCompanentFOne {...props} idOne={356} codeOne={"print"} nameValeuOne={"Только однотонные"} />
          <DisplayTypeCompanentFOne {...props} idOne={342} codeOne={"class"} nameValeuOne={"Только распродажа"} />
        </>

      }

    </>
  )
}

export default DisplayTypeCompanentA;